import React from 'react'
import Helmet from 'react-helmet'
import Header from './Header'
import Footer from './Footer'

import style from "./index.module.css";

export default ({ children }) => {
  return (
    <div>
      <Helmet>
        <html lang="nl" />
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta http-equiv="x-ua-compatible" content="IE=edge" />
        <title>Hilversum100</title>
        {/* <script src="https://polyfill.io/v2/polyfill.min.js"></script> */}
      </Helmet>
      <Header />
      <div id="contentContainer" className={style.container}>
        {children}
      </div>
      <Footer />
    </div>
  )
}